export default __webpack_public_path__ + "static/media/dress15.40a357bd.jpeg";